/********************  START WEB API SLUG ************* */

// Prefixed WEB URL

//Athencation
const ADMIN = '/api/admin/';
const API = '/api/';
export const LOGIN = 'login';
export const CHANGE_PASSWORD = API + 'change-password';

// dashboard Data
export const GET_DASHBOARD_DATA = API + 'dashboard-data';

// user
export const GET_USER_LIST = API + 'users-list';
export const DELETE_USER = API + 'users-delete';
export const SAVE_USER_DATA = API + 'users-add';
export const UPDATE_USER_DATA = API + 'users-update';

// Employee
export const DELETE_EMPLOYEE = API + 'users-delete';
export const GET_LIST_EMPLOYEE = API + 'list-employee';
export const UPDATE_EMPLOYEE = API + 'update-employee';
export const ADD_EMPLOYEE = API + 'add-employee';

// list-employee
export const UPDATE_PAYSTUB_DATA = API + 'add-paystub-data';

// module 2

// get employee by id
export const GET_EMPLOYEE_BY_ID = API + 'employee-get-by-id';

// connect with us form
export const CONNECT_WITH_US_FORM = API + 'add-tax-form-details';

// tax-file-list
export const TAX_LIST = API + 'tax-form-list';

// tax-list-detail
export const TAX_LIST_DETAIL = API + 'tax-form-data-by-id';

// get available slot
export const GET_AVAILABLE_SLOTS = API + 'available-slots';

// get details summary of tax payer after slot booked
export const GET_DETAIL_SUMMARY_TAXPAYER = API + 'tax-form-data';

// book slot
export const BOOK_SLOT = API + 'book-slot';

// update slot count
export const UPDATE_SLOT_COUNT = API + 'update-global-data';

// global setting
export const GET_GLOBAL_DATA = API + 'get-global-data';

// approve document
export const APPROVE_DOCUMENT = API + 'change-document-status';

// edit document
export const EDIT_DOCUMENT = API + 'edit-document';

// proceed to payment
export const GET_PAYMENT_LINK = API + 'payment-link';

// need review status change in tax payer list
export const NEED_REVIEW_STATUS_CHANGE = API + 'change-tax-form-status';

// view sin number
export const VIEW_SIN_NUMBER = API + 'confirm-sin-no';

// post document to be signed by taxpayer
export const POST_SIGNED_DOC = API + 'upload-doc-for-sign';

// update tax filing dates
export const UPDATE_TAX_FILING_DATES = API + 'update-slot';

// update tax payer email
export const UPDATE_TAXPAYER_EMAIL = API + 'update-candidate-email';

// get form upload payment detail
export const GET_FORM_PAYMENT_DETAIL = API + '';

// add tax payer manually
export const ADD_TAXPAYER_MANUALLY = API + 'add-tax-payer-data-manually';

// get document to be signed
export const GET_DOCUMENT_TO_BE_SIGNED = API + 'get-document';

// get document to be signed
export const UPLOAD_SIGNED_DOC = API + 'upload-signed-doc';

// resend balance amount payment link
export const RESEND_BALANCE_AMOUNT_PAYMENT_LINK =
  API + 'resend-balance-amount-payment-link';

// update taxpayer note
export const UPDATE_TAXPAYER_NOTE = API + 'update-tax-form-data';

//E-Transfer payment status change
export const CHANGE_PAYMENT_STATUS = API + 'change-payment-status';

// get current date and time
export const GET_CURRENT_DATE_TIME = API + 'get-current-date-time';

export const RESEND_SIGN_DOC_EMAIL = API + 'resend-sign-doc-email';

// pending tax form list
export const PENDING_TAX_FORM_LIST = API + 'pending-tax-form-list';

// pending tax form list
export const ADD_COMPANY_DETAILS = API + 'add-company-details';

// list companies
export const LIST_COMPANIES = API + 'list-companies';

// edit company details
export const DELETE_COMPANY = API + 'delete-company';
export const EDIT_COMPANY_DETAILS = API + 'edit-company-details';

// company tax filing list
export const COMPANY_TAX_FILING_LIST = API + 'company-tax-filing-list';

// company gst filing list
export const COMPANY_GST_FILING_LIST = API + 'company-gst-filing-list';

// company wcb filing list
export const COMPANY_WCB_FILING_LIST = API + 'company-wcb-filing-list';

// company tax filing status change
export const COMPANY_TAX_FILING_STATUS_CHANGE = API + 'company-tax-filing-status-change';

// company gst filing status change
export const COMPANY_GST_FILING_STATUS_CHANGE = API + 'company-gst-filing-status-change';

// company wcb filing status change
export const COMPANY_WCB_FILING_STATUS_CHANGE = API + 'company-wcb-filing-status-change';

// upload company signed tax filing doc
export const UPLOAD_COMPANY_SIGNED_TAX_FILING_DOC = API + 'upload-company-signed-tax-filing-doc';

// upload company tax filing doc
export const UPLOAD_COMPANY_TAX_FILING_DOC = API + 'upload-company-tax-filing-doc';

// upload company tax filing doc
export const COMPANY_TAX_FILING_PAYMENT = API + 'company-tax-filing-payment';

// get document for sign
export const GET_DOCUMENT_FOR_SIGN = API + 'get-document-for-sign';

// change employee status
export const CHANGE_EMPLOYEE_STATUS = API + 'change-employee-status';

// change employee status
export const CHANGE_TAX_FILING_STATUS_OF_COMPANY = API + 'company-tax-filing-status-change';

// uber calculation
export const LIST_UBER_CALCULATIONS = API + 'list-uber-calculations';
export const GET_UBER_CALCULATION = API + 'uber-calculation';
export const ADD_UBER_CALCULATION = API + 'add-uber-calculation';
export const UPDATE_UBER_CALCULATION = API + 'update-uber-calculation';
export const DELETE_UBER_CALCULATION = API + 'uber-calculation';
export const PREVIEW_UBER_CALCULATION = API + 'preview-uber-calculation';
export const UBER_CALCULATION_STATUS = API + 'uber-calculation-status';
export const UBER_CALCULATION_PDF = API + 'uber-calculation-pdf';
export const LIST_GST_INCOME = API + 'list-gst-income';
export const LIST_GST_EXPENSE = API + 'list-gst-expense';
export const ADD_GST_INCOME = API + 'add-gst-income';
export const ADD_GST_EXPENSE = API + 'add-gst-expense';
// confirm employee performance password
export const CONFIRM_EMP_PERF_PASS = API + 'confirm-emp-perf-pass';

// employee list for tax
export const GET_EMPLOYEE_FORM_BY_SIN_EMAIL = API + 'tax-form-by-sin-email';

// update doucment of employee
export const UPDATE_EMPLOYEE_DOCUMENTS = API + 'update-documents';

// tax form documents
export const GET_TAX_FORM_DOCUMENTS = API + 'tax-form-documents';

// send document note email
export const SEND_DOCUMENT_NOTE_EMAIL = API + 'send-document-note-email';